<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    width="40"
    height="40"
    fill="none"
  >
    <path
      d="M17.1816 20.3398C17.1816 20.5352 17.2598 20.7109 17.4062 20.8574L24.7598 27.9375C24.8965 28.0742 25.0723 28.1523 25.2773 28.1523C25.6777 28.1523 25.9902 27.8398 25.9902 27.4297C25.9902 27.2246 25.9121 27.0586 25.7852 26.9219L18.9395 20.3398L25.7852 13.748C25.9121 13.6113 25.9902 13.4355 25.9902 13.2402C25.9902 12.8301 25.6777 12.5273 25.2773 12.5273C25.0723 12.5273 24.8965 12.5957 24.7598 12.7324L17.4062 19.8125C17.2598 19.959 17.1816 20.1348 17.1816 20.3398Z"
      :fill="fill"
    />
    <line
      x1="14.6"
      y1="12.6"
      x2="14.6"
      y2="28.4"
      :stroke="fill"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: ["width", "height", "fill"],
};
</script>

<style></style>
